const outsideClick = {
    mounted: function (el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
            // here I check that click was outside the el and has childrens
            if (!(el === event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                if (typeof binding.value === 'function') {
                    binding.instance[binding.expression](event)
                } else {
                    binding.instance[binding.value.toggleState] = false
                    document.body.removeEventListener('click', el.clickOutsideEvent)
                }
            }
        }
        if (typeof binding.value === 'function') {
            document.body.addEventListener('click', el.clickOutsideEvent)
        } else {
            el.onclick = () => {
                binding.instance[binding.value.toggleState] =
          !binding.instance[binding.value.toggleState]
                document.body.addEventListener('click', el.clickOutsideEvent)
            }
        }
    },
    unmounted: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    }
}

export default outsideClick
